var map = {
	"./RoomT1/T1(1).jpg": 6950,
	"./RoomT1/T1(2).jpg": 8059,
	"./RoomT1/T1(3).jpg": 5200,
	"./RoomT1/T1(4).jpg": 7230,
	"./RoomT2/T2(1).jpg": 4040,
	"./RoomT2/T2(2).jpg": 2086,
	"./RoomT2/T2(3).jpg": 3854,
	"./RoomT2/T2(4).jpg": 9766,
	"./RoomT3/T3(1).jpg": 3508,
	"./RoomT3/T3(2).jpg": 9518,
	"./RoomT3/T3(3).jpg": 7664,
	"./RoomT3/T3(4).jpg": 7884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9718;